import { useContext } from 'react';
import { UserContext } from '../../contexts/user-context';
import { useVenturesContext } from '../../contexts/ventures-context';
import { ModalV2 } from '../common';
import { AssignFoundersForm } from '../forms/assign-founders';

function FounderAssignmentModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    foundersAssignmentTargetVenture,
    isFoundersAssigningVenture,
    loadedFoundersById,
    handleFoundersLoaded,
    assignFoundersSuccessForm,
    setFoundersAssignmentTargetVenture,
  } = useVenturesContext();

  const handleClose = () => {
    setFoundersAssignmentTargetVenture(null);
  };

  return hasAccessToAction('venture.details.update') &&
    foundersAssignmentTargetVenture ? (
    <ModalV2
      open={!!foundersAssignmentTargetVenture}
      onClose={handleClose}
      titleProps={{
        title: 'New assignment',
        caption: `${foundersAssignmentTargetVenture.ventureName}`,
      }}
      width='720px'>
      <AssignFoundersForm
        ventureId={foundersAssignmentTargetVenture.id}
        loading={isFoundersAssigningVenture[foundersAssignmentTargetVenture.id]}
        onLoaded={handleFoundersLoaded(foundersAssignmentTargetVenture.id)}
        founders={loadedFoundersById[foundersAssignmentTargetVenture.id]}
        onSuccess={assignFoundersSuccessForm(
          foundersAssignmentTargetVenture.id,
          handleClose,
        )}
        onCancel={handleClose}
      />
    </ModalV2>
  ) : null;
}

export default FounderAssignmentModal;
